<template>
	<div :class="{ 'list': true, 'list--loading': loading }">
		<!-- Hide table entirely if set to only "new" users and no results -->
		<Vuetable v-if="!(newOnly && empty)"
				  ref="vuetable" :api-url="suspendedOnly ? 'suspended_users' : 'users'" :fields="fields" :css="css"
		          pagination-path="meta"
		          @vuetable:pagination-data="onPaginationData"
		          @vuetable:loading="onLoading"
		          @vuetable:loaded="onLoaded" @vuetable-load-error="onLoadError"
		          :http-fetch="fetch"
		          :append-params="userFilters"
		          :load-on-start="loadOnStart"
		          :sort-order="sortOrder"
		          :min-rows="loading ? 10 : null"
		          :no-data-template="loaded && !newOnly ? 'No users found' : ''"
		></Vuetable>

		<!-- Error while loading -->
		<div class="list__error" v-if="error">
			<span class="h2">Unable to load users.</span>
			<button class="btn btn--link" @click.prevent="load">Retry</button>
		</div>

		<!-- Showing only "new" users and no results -->
		<div class="list__empty" v-if="newOnly && empty">
			<span class="h2">You're all up to date!</span>
			<router-link to="/users" class="btn btn--link">View all users</router-link>
		</div>

		<Pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></Pagination>
	</div>
</template>

<script>
	import Vue from 'vue';
	import Vuetable from 'vuetable-2/src/components/Vuetable';
	import ColumnUser from './ColumnUser';
	import ColumnSector from './ColumnSector';
	import ColumnImpersonate from './ColumnImpersonate';
	import Pagination from './Pagination';
	import FilterableList from './FilterableList';

	Vue.component('column-user', ColumnUser);
	Vue.component('column-sectors', ColumnSector);
	Vue.component('column-impersonate', ColumnImpersonate);

	export default {
		name: 'ListUsers',
		mixins: [FilterableList],
		components: {
			Pagination,
			Vuetable,
		},
		props: {
			inactiveOnly: {
				type: Boolean,
				default: false,
			},
			suspendedOnly: {
				type: Boolean,
				default: false,
			},
			showImpersonate: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			let fields =  [
				{
					name: '__component:column-user',
					sortField: 'last_name',
					title: 'User Name',
				},
				{
					name: 'member',
					sortField: 'member.name.sort',
					title: 'Company',
					width: '300px',
				},
				{
					name: 'office',
					sortField: 'office.name',
					title: 'Location',
					width: '150px',
				},
				{
					name: '__component:column-sectors',
					title: 'Specialised Sector',
					width: '300px',
				},
				{
					name: 'lastLoggedIn',
					sortField: 'logged_in_at',
					title: 'Last Logged-in',
					titleClass: 'right',
					callback: 'formatDate',
					width: '175px',
				}
			];

			if(this.showImpersonate) {
				fields.push({
					name: '__component:column-impersonate',
					title: '',
					width: '175px',
                    data: {
                        event: this.$store.getters.event
                    }
				});
			}

			return {
				sortOrder:[
					{
						field: 'last_name',
						direction: 'asc'
					}
				],
				fields,
			};
		},
		computed: {
			userFilters() {
				let filters = JSON.parse(JSON.stringify(this.filters));

				if(this.inactiveOnly) {
					filters.inactive = true;
				}

				if(this.suspendedOnly) {
					filters.suspended = true;
				}

				return filters;
			}
		}
	}
</script>
